import React, { useEffect } from "react";
import WelcomeJourneyFooter from "../WelcomeJourneyFooter";
import { useRouter } from "next/compat/router";
import { useDispatch, useSelector } from "react-redux";
import { WelcomeJourneyState, isVisited, welcomeStep } from "@/redux/actions/pwaAction";
import { openAccountSidebar } from "@/redux/actions/loggedInUser";

//OS-4148: CR - Welcome jounery Step 2 (Login landing screen)
const LoginLandingScreen = (props) => {
  const dispatch = useDispatch();
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);

  const handlebtn1Click = () => {
    //added transition to account drawer
    // document.querySelector("body").classList.add("pwa-transition");
    dispatch(openAccountSidebar(true))
    // setTimeout(() => {
    //   document.querySelector("body").classList.remove("pwa-transition");
    // }, 2000);
    // props.setShowWcJourney(false);
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: false,currentStepNo:3 }));
  }
  const handlebtn2Click = () =>{
    props.changeStep(5)
  }

  return (
    <>
      <div
        className="rewards_block"
        style={{
          backgroundImage:
            "url('https://cdn.shopify.com/s/files/1/0555/6165/0255/files/800x1340_x2_37ec71c4-1554-4117-85e0-06b2875f6b93.png?v=1713247880')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        &nbsp;
      </div>
      <WelcomeJourneyFooter
        heading="Start shopping"
        description="Log in for a personalized experience, track your impact and earn Olivela Rewards."
        btn1_text="Log in / register"
        btn1ClickHandler={handlebtn1Click}
        ga4tag1="App: WJ - Login > Log in / register"
        btn2_text="Continue as guest"
        btn2ClickHandler={handlebtn2Click}
        ga4tag2="App: WJ - Login > Continue as guest"
      />
    </>
  );
};

export default LoginLandingScreen;
